import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom';
import { CustomTab } from '../../../components';
import { Box } from '@mui/material';

const RouteTabScreen = () => {
  const navigate = useNavigate();

  return (
    <Box mt={-2}>
      <CustomTab
        panels={[
          {
            name: "Recargas Celular",
            route: '/ruteo/panel/tae',
            onChange: () => navigate('tae'),
            content: <Outlet />
          },
          {
            name: "Pago de Servicios",
            route: '/ruteo/panel/pds',
            onChange: () => navigate('pds'),
            content: <Outlet />
          },
          {
            name: "Tarjetas de Regalo",
            route: '/ruteo/panel/pin',
            onChange: () => navigate('pin'),
            content: <Outlet />
          }
        ]}
      />
    </Box>
  );
}

export default RouteTabScreen